import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

// export const ssoTokenGuard: CanActivateFn = (route, state) => {
//   return true;
// };
@Injectable({
  providedIn: 'root',
})
export class ssoTokenGuard {
  constructor(private router: Router, private location: Location) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const url = new URL(window.location.href);
    const rtoken = url.searchParams.get('rtoken');

    if (rtoken !== null) {
      this.router.navigate(['/login'], { queryParams: { rtoken } });
      
      return false; // Prevent navigation to the originally requested route
    }

    return true; // Allow navigation to the originally requested route
  }
}

export const SsotokenGuard: CanActivateFn = (): Observable<boolean> | Promise<boolean> | boolean  => {
    const router = inject(Router);
    const url = new URL(window.location.href);
    const ssoToken = url.searchParams.get('SSORequestToken');
    const gatekeeperKey = url.searchParams.get('gatekeeperKey');

    //if there is an sso token route request to investor application and append all query params
    if (ssoToken !== null || gatekeeperKey !== null) {
      const targetUrl = `/app/#/login${url.search}`;
      window.location.href = targetUrl;
      return false;
    }
  
    return true;
  
};